module.exports = __webpack_public_path__ + "static/five-roses-37a1de3a456526919880894bfe736548.jpg";